'use client';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

import { ProductPriceCardItem } from '../models/product-price-card-item.model';

import { ProductPriceCardV2 } from './product-price-card-v2';

interface Props {
   productPriceCardItems: ProductPriceCardItem[];
   productDetailBaseRoute: string;
   quoteDetailBaseRoute: string | null;
   limitedProductDetailBaseRoute: string | null;
   tdsAnchor: string | undefined;
   channel: string;
   canViewPrices: boolean;
   showOfflinePrices: boolean;
}

export const ProductPriceListClientV2 = ({
   productPriceCardItems,
   productDetailBaseRoute,
   quoteDetailBaseRoute,
   limitedProductDetailBaseRoute,
   tdsAnchor,
   channel,
   canViewPrices,
   showOfflinePrices
}: Props) => (
   <Box direction="column" gap="sm">
      {productPriceCardItems.map((value, index) => (
         <ProductPriceCardV2
            /* eslint-disable-next-line @eslint-react/no-array-index-key */
            key={`${value.productId}-${index}`}
            productPriceCardItemId={`${value.productId}-${index}`}
            productPriceCardItem={value}
            productDetailBaseRoute={productDetailBaseRoute}
            quoteDetailBaseRoute={quoteDetailBaseRoute}
            limitedProductDetailBaseRoute={limitedProductDetailBaseRoute}
            tdsAnchor={tdsAnchor}
            channel={channel}
            canViewPrices={canViewPrices}
            showOfflinePrices={showOfflinePrices}
         />
      ))}
   </Box>
);
